import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, FormInput, FormSelect, Row } from 'shards-react'
import { setFormData, hiringPlanActions } from '../../../../redux/reducers/HiringPlan/hiringPlanReducer';
import styles from '../styles.module.css'
import { organizationList } from '../../../../redux/reducers/organization-list-reducer'
import { getYearsList } from '../../../../utils/smallHelpers';
import { ORG_TYPES } from '../../../../constants/const';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ru } from 'date-fns/locale';
import moment from 'moment';

registerLocale('ru', ru);



const Form = ({ form }) => {
  
  const yearsList = getYearsList(2025, 2027)

  const dispatch = useDispatch()

  const orgList = useSelector(state => state.reports.orgList.data)
  const auth = useSelector(state => state.auth.data)

  useEffect(() => {
    if (orgList !== undefined && orgList.length === 0) {
      dispatch(organizationList.organizationListRequestStart(auth))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    const addschool = (name === 'idOrg' && value !== '0') ? "0" : form.addschool
    dispatch(setFormData({ ...form, addschool, [name]: value }))
  }

  const handleDateChange = (name, date) => {
    const value = date ? moment(date).format('DD.MM') : ''
    dispatch(setFormData({ ...form, [name]: value }))
  }

  const currentYear = new Date().getFullYear()

  const parseDateValue = (value) => {
    if (!value) return null
    const [day, month] = value.split('.')
    if (!day || !month) return null
    return moment(`${currentYear}-${month}-${day}`, 'YYYY-MM-DD').toDate()
  }

  const renderDatePickerHeader = ({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
    <div className={styles.datePickerHeader}>
      <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{'‹'}</button>
      <span>{date.toLocaleString('ru', { month: 'long' })}</span>
      <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{'›'}</button>
    </div>
  )

  const onSubmit = () => {
    dispatch(hiringPlanActions.hiringPlanRequestStart())
  }

  return (
    <Row className={styles.formRow}>
        
        <Col md={2}>
          <label htmlFor="year">Выберите год</label>
          <FormSelect
              id='year'
              name='year'
              size="sm"
              value={form.year}
              onChange={handleChange}
          >
              {yearsList.map(year => <option key={year} value={year}>{year}</option>)}
          </FormSelect>
        </Col>

        <Col md={1}>
          <label htmlFor="from_date">Дата с</label>
          <DatePicker
              id='from_date'
              selected={parseDateValue(form.from_date)}
              onChange={(date) => handleDateChange('from_date', date)}
              dateFormat="dd.MM"
              placeholderText="ДД.ММ"
              className="form-control form-control-sm"
              locale="ru"
              renderCustomHeader={renderDatePickerHeader}
              showMonthDropdown={false}
              showYearDropdown={false}
          />
        </Col>

        <Col md={1}>
          <label htmlFor="to_date">Дата по</label>
          <DatePicker
              id='to_date'
              selected={parseDateValue(form.to_date)}
              onChange={(date) => handleDateChange('to_date', date)}
              dateFormat="dd.MM"
              placeholderText="ДД.ММ"
              className="form-control form-control-sm"
              locale="ru"
              renderCustomHeader={renderDatePickerHeader}
              showMonthDropdown={false}
              showYearDropdown={false}
          />
        </Col>

        <Col md={5}>
            <label htmlFor='idorg'>Выберите организацию</label>
            <FormSelect
              name='idorg'
              id='idorg'
              size='sm'
              className='d-block'
              value={form.idorg}
              onChange={handleChange}
            >
              <option value='0'>Все организации</option>
              {!!orgList && orgList.map(item => (
                <option key={item.idOrganization} value={item.idOrganization}>
                  {item.orgName}
                </option>
              ))}
            </FormSelect>
        </Col>

        {form.idorg === '0' && (
          <Col md={2}>
              <label htmlFor='school'>Тип ОО</label>
              <FormSelect
                name='school'
                id='school'
                size='sm'
                className='md-block'
                onChange={handleChange}
                value={form.school}
              >
                {ORG_TYPES.map(({name, value}) => <option key={value} value={value}>{name}</option>)}
              </FormSelect>
          </Col>
        )}

        <Button style={{margin: '0 15px'}} onClick={onSubmit}>Создать отчет</Button>

    </Row>
  )
}

export default Form
